import './SharedWholeProjectNote.css';

/** Shown in a file preview when the open document is the one whole-project file. */
export default function SharedWholeProjectNote() {
  return (
    <p className="pf-shared-file-note" role="note">
      Comments, markup, and edits on this file are shared across every structure because it represents the whole project from the designer’s upload.
    </p>
  );
}
